/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./spinner.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./spinner.component";
var styles_SpinnerComponent = [i0.styles];
var RenderType_SpinnerComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_SpinnerComponent, data: {} });
export { RenderType_SpinnerComponent as RenderType_SpinnerComponent };
export function View_SpinnerComponent_0(_l) { return i1.ɵvid(2, [i1.ɵqud(402653184, 1, { target: 0 }), (_l()(), i1.ɵeld(1, 0, [[1, 0], ["inner", 1]], null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_SpinnerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-spinner", [], null, null, null, View_SpinnerComponent_0, RenderType_SpinnerComponent)), i1.ɵdid(1, 638976, null, 0, i2.SpinnerComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SpinnerComponentNgFactory = i1.ɵccf("app-spinner", i2.SpinnerComponent, View_SpinnerComponent_Host_0, { type: "type", color: "color" }, {}, []);
export { SpinnerComponentNgFactory as SpinnerComponentNgFactory };
